import React from "react";
import { Box, Button, Flex, Image, Link, Space } from "@chakra-ui/react";
import Twitter from "../assets/social-media-icons/twitter.png";
import Opensea from "../assets/social-media-icons/opensea.png";
import Etherscan from "../assets/social-media-icons/etherscan.png";

const NavBar = ({ accounts, setAccounts, contractAddress }) => {
  const isConnected = Boolean(accounts[0]);

  async function connectAccounts() {
    if (window.ethereum) {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setAccounts(accounts);
    }
  }

  return (
    <Flex justify="space-between" align="center" padding="30px">
      {/* TODO */}
      <Box margin="0 15px">NOT AIMOONBIRDS</Box>

      {/* TODO */}
      {/* <Flex justify="space-around" width="40%" padding="0 75px">
        <Link href="https://www.twitter.com/savegodjira">
          <Image src={Twitter} boxSize="42px" margin="0 15px"></Image>
        </Link>
      </Flex>
      <Flex justify="space-around" width="40%" padding="0 75px">
        <Link href="https://www.twitter.com/savegodjira">
          <Image src={Twitter} boxSize="42px" margin="0 15px"></Image>
        </Link>
      </Flex> */}
      <Box boxSize="42px" margin="0 15px"></Box>
      <Box boxSize="42px" margin="0 15px"></Box>
      <Box boxSize="42px" margin="0 15px"></Box>
      <Box boxSize="42px" margin="0 15px"></Box>
      <Box boxSize="42px" margin="0 15px"></Box>
      <Link href="https://www.twitter.com/notaimoonbirds">
        <Image src={Twitter} boxSize="42px" margin="0 15px"></Image>
      </Link>
      <Link href="https://opensea.io/collection/notaimoonbirdss">
        <Image src={Opensea} boxSize="42px" margin="0 15px"></Image>
      </Link>
      <Link href={`https://etherscan.io/address/${contractAddress}`}>
        <Image src={Etherscan} boxSize="42px" margin="0 15px"></Image>
      </Link>

      {/* Connected */}
      {isConnected ? (
        <Button
          backgroundColor="#D6517D"
          borderRadius="5px"
          boxShadow="0px 2px 2px 1px #0F0F0F"
          color="white"
          cursor="pointer"
          fontFamily="inherit"
          padding="15px"
          marginTop="10px"
          margin="0 15px"
        >
          {accounts[0].substring(0, 6) +
            "..." +
            accounts[0].substring(accounts[0].length - 4, accounts[0].length)}
        </Button>
      ) : (
        <Button
          backgroundColor="#DB517D"
          borderRadius="5px"
          boxShadow="0px 2px 2px 1px #0F0F0F"
          color="white"
          cursor="pointer"
          fontFamily="inherit"
          padding="15px"
          margin="0 15px"
          onClick={connectAccounts}
        >
          Connect Wallet
        </Button>
      )}
    </Flex>
  );
};

export default NavBar;
